import { createNavigationContainerRef, StackActions } from '@react-navigation/native';
import { DashboardStackParams } from './AppNavigationProps';

export const navigationRef = createNavigationContainerRef<DashboardStackParams>();

type Screen = keyof DashboardStackParams;

export class Navigation {
  static navigate = <T extends Screen>(name: T, params?: DashboardStackParams[T]) => {
    navigationRef.current?.navigate<any>(name, params);
  };

  static push = <T extends Screen>(name: T, params?: DashboardStackParams[T]) => {
    navigationRef.current?.dispatch(StackActions.push(name, params));
  };

  static popToTop = () => {
    navigationRef.current?.dispatch(StackActions.popToTop());
  };

  static pop = () => {
    navigationRef.current?.goBack();
  };
}
